import styled from 'styled-components';
import Link from 'next/link';
import { useQuery } from '@tanstack/react-query';

import { ListingServices } from '@services';
import staticMenuItems from '@lib/menuItems';
import { Caption2, Subtitle3 } from '@components/styles/Typography';

const ListingCategoryMenu = ({
    category,
    filterCount,
    locale,
    productCount,
}) => {
    const { data, isLoading } = useQuery({
        queryKey: ['getMenuItems'],
        queryFn: ListingServices.getMenuItems,
    });
    const menuItems = isLoading ? staticMenuItems : data?.data;
    return (
        <Wrapper>
            {menuItems?.map((menuItem) => {
                const slug = menuItem.slug[locale];
                const slugWithQueries = () => {
                    if (
                        menuItem.sort !== 'newProduct' &&
                        menuItem.sort !== undefined
                    ) {
                        return `${slug}?order=${menuItem.sort}`;
                    }
                    return slug;
                };

                return (
                    <Item
                        key={menuItem.slug.en}
                        href={slugWithQueries()}
                        selected={slug === category}
                        passHref
                    >
                        {/* <Item> */}
                        {slug === 'goat' ? (
                            <GoatIcon
                                src="/goatIcon.png"
                                alt="Goat"
                                width="50px"
                            />
                        ) : (
                            <Subtitle3
                                color={
                                    slug !== category ? 'bgGray25' : 'primary'
                                }
                            >
                                {menuItem.name[locale]}
                            </Subtitle3>
                        )}
                        <div>
                            {slug === category && (
                                <Caption2>{menuItem?.productCount}</Caption2>
                            )}
                            {filterCount > 0 && slug === category && (
                                <Caption2>{`${productCount} / ${menuItem?.productCount}`}</Caption2>
                            )}
                        </div>
                        {/* </Item> */}
                    </Item>
                );
            })}
        </Wrapper>
    );
};
const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
    transition: all 0.3s ease-in;
    padding: 0 15px;
    position: relative;

    ::-webkit-scrollbar {
        display: none;
    }
    @media (max-width: 768px) {
        overflow-y: auto;
    }
`;

const Item = styled(Link)`
    position: relative;
    margin-left: 15px;
    margin-top: 15px;
    white-space: nowrap;
    :first-child {
        margin-left: 0;
    }
    div {
        position: absolute;
        top: -15px;
        right: -6px;
    }
`;

const GoatIcon = styled.img`
    width: 54px;
    display: block;
    margin-top: -2px;
`;

export default ListingCategoryMenu;
